import Warning from '~/errors/Warning';
import { NotificationT } from '~/libs/soopI18n';

class ResponseError extends Warning {
    response: unknown;

    constructor(message: string, response?: unknown) {
        super(message);
        this.response = response;
        this.productionMessage =
            NotificationT('잘못된 응답입니다. 잠시 후 다시 시도해주세요.');

        this.name = 'ResponseError';
    }
}

export default ResponseError;
